<template>
  <modal
    :show="showMe"
    class="modal-primary"
    :show-close="false"
    header-classes="justify-content-center"
    type="mini"
    :click-to-close="false"
  >
    <ValidationObserver ref="itemForm">
      <form @submit.prevent="save">
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="budgetItemId"
              rules="required"
            >
              <fg-input
                slot-scope="{ errors }"
                :error="errors[0] ? 'Please provide the budget item to track this expense to.': '' "
              >
                <label class="control-label">Budget Line <span class="text-danger">*</span></label>
                <el-select
                  class="select-default2"
                  size="large"
                  name="budgetItemId"
                  placeholder=""
                  clearable
                  v-model="item.BudgetItemId"
                >
                  <el-option
                    v-for="bi in budgetItems"
                    class="select-default2"
                    :value="bi.Id"
                    :label="bi.Title"
                    :key="bi.Id"
                  />
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="col-md-4">
            <ValidationProvider
              name="amount"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <div class="form-group">
                <label class="control-label">Amount <span class="text-danger">*</span></label>
                <fg-input
                  name="amount"
                  type="number"
                  step="0.01"
                  :has-success="passed"
                  :error="failed ? 'The amount is required.': null"
                  v-model="item.Amount"
                />
              </div>
            </ValidationProvider>
          </div>
          <div class="col-md-2">
            <p-button
              type="default"
              native-type="submit"
              class="mt-4"
            >
              save
            </p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'ReceiptDetailsLine',
  components: {
    Modal
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    budgetItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    show: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    showMe: function () {
      return this.show
    }
  },
  methods: {
    save: function () {
      return this.$refs.itemForm.validate().then(res => {
        if (res) {
          this.$emit('update-receipt-line', this.item)
        }
        return res
      })
    }
  }
}
</script>
